import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {HOSTNAME, LargeDataAnalyticsHostname} from "../configs/Domain";
import { createQueryParams, hashParams  } from './_apiUtils';


const UrlMap = {
    pcaDecomposition: `${LargeDataAnalyticsHostname}/analysis/decompose/pca`,
    ellipticalCopulas: `${LargeDataAnalyticsHostname}/dependence/copulas/elliptical`,
}


export const createModelFetchThunk = (modelName, url) =>
  createAsyncThunk(
    `analytics/fetch${modelName}Model`,
    async ({ symbols, startDate, endDate }, { rejectWithValue }) => {
      const queryParams = createQueryParams({ symbols, start_date: startDate, end_date: endDate });
      try {
        const response = await fetch(`${url}?${queryParams}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return { ...data, modelName };
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const fetchPcaModel = createModelFetchThunk('pca', UrlMap.pcaDecomposition);
export const fetchCopulaModel = createModelFetchThunk('copula', UrlMap.ellipticalCopulas);